// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"38":"bbf8daf0","339":"934d60b1"}[chunkId] + ".js";
};